export default __webpack_public_path__ + "static/media/lineHeight.ff8f63a4.svg";